import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["checked"];
var _div, _CheckmarkCircle, _Info;
import { useCallback, useEffect, useState } from 'react';
import CheckmarkCircle2 from '@crehana/compass.icons.outline/CheckmarkCircle2';
import Info from '@crehana/compass.icons.outline/Info';
import { Checkbox } from '@crehana/ui';
import { useUIContext } from "../../context/UI";
import { useTranslation } from "../../hooks";
import { ContentSuggestions } from "./GenerateNote.styles";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Suggestions = function Suggestions(_ref) {
  var canSelect = _ref.canSelect,
    isSaveNote = _ref.isSaveNote,
    noteSuggestions = _ref.noteSuggestions,
    selectNotes = _ref.selectNotes;
  var _useUIContext = useUIContext(),
    header = _useUIContext.header,
    changeGenerateAI = _useUIContext.changeGenerateAI;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    mockNote = _useState2[0],
    setMockNote = _useState2[1];
  var handleToggle = function handleToggle(index) {
    if (mockNote) {
      var updatedNote = mockNote.map(function (elem) {
        if (elem.id === index) {
          return _objectSpread(_objectSpread({}, elem), {}, {
            checked: !elem.checked
          });
        }
        return elem;
      });
      setMockNote(updatedNote);
    }
  };
  var addCheckType = useCallback(function (noteData) {
    return noteData.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        checked: false
      });
    });
  }, []);
  useEffect(function () {
    if (noteSuggestions) {
      setMockNote(addCheckType(noteSuggestions));
    }
  }, [noteSuggestions, addCheckType]);
  var content = function content() {
    if (mockNote.length > 0) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [_div || (_div = /*#__PURE__*/_jsx("div", {
          className: "tw-mb-3.2 tw-w-full tw-border-b tw-border-solid tw-border-neutral-dark-700",
          role: "separator"
        })), /*#__PURE__*/_jsx("div", {
          className: "tw-flex tw-flex-col",
          children: mockNote.map(function (_ref2) {
            var description = _ref2.description,
              checked = _ref2.checked,
              id = _ref2.id;
            return /*#__PURE__*/_jsx(Checkbox, {
              label: description,
              isDark: true,
              checked: checked,
              className: "tw-mb-1.2",
              onChange: function onChange() {
                return handleToggle(id);
              }
            }, "note_".concat(id));
          })
        })]
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "tw-text-neutral-light-100 tw-flex tw-flex-col tw-w-[50rem] tw-text-center tw-items-center tw-m-auto tw-my-3.2",
      children: [_CheckmarkCircle || (_CheckmarkCircle = /*#__PURE__*/_jsx(CheckmarkCircle2, {
        size: 48,
        className: "tw-mb-2.4 tw-fill-current tw-text-secondary-dark-400"
      })), /*#__PURE__*/_jsx("span", {
        className: "tw-font-subtitle4 tw-mb-0.8",
        children: t('AI_SUCCESS_TITLE')
      }), /*#__PURE__*/_jsx("span", {
        className: "tw-font-body4",
        children: t('AI_SUCCESS_SUBTITLE')
      })]
    });
  };
  var selectData = useCallback(function () {
    if (mockNote) {
      selectNotes(mockNote.filter(function (item) {
        return item.checked;
      }).map(function (_ref3) {
        var checked = _ref3.checked,
          arg = _objectWithoutProperties(_ref3, _excluded);
        return arg;
      }));
      var dataAux = mockNote.filter(function (item) {
        return !item.checked;
      });
      if (dataAux.length === 0) {
        changeGenerateAI('successNoteEmpty');
      }
      setMockNote(dataAux);
    }
  }, [mockNote, selectNotes, changeGenerateAI]);
  useEffect(function () {
    if (mockNote) {
      canSelect(mockNote.some(function (item) {
        return item.checked;
      }));
    }
  }, [mockNote, canSelect]);
  useEffect(function () {
    if (isSaveNote) {
      selectData();
    }
  }, [isSaveNote, selectData]);
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-px-2.4",
    children: [!!(header !== null && header !== void 0 && header.subtitle) && /*#__PURE__*/_jsx("div", {
      className: "tw-my-1.6 tw-bg-elevation-dark-04 tw-font-subtitle5 tw-text-neutral-light-100 tw-px-1.2 tw-py-0.8 tw-rounded-1 tw-w-fit",
      children: header === null || header === void 0 ? void 0 : header.subtitle
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-font-body4 tw-text-neutral-dark-300",
      children: [_Info || (_Info = /*#__PURE__*/_jsx(Info, {
        size: 24,
        className: "tw-fill-current tw-mr-1.2"
      })), /*#__PURE__*/_jsx("span", {
        children: t('AI_SUGGESTIONS_DESCRIPTION')
      })]
    }), /*#__PURE__*/_jsx(ContentSuggestions, {
      className: " tw-max-h-[23rem] tw-overflow-y-auto",
      children: content()
    })]
  });
};
export default Suggestions;